import { render, staticRenderFns } from "./BirthdayTemplate.vue?vue&type=template&id=37e5ae64&"
import script from "./BirthdayTemplate.vue?vue&type=script&lang=js&"
export * from "./BirthdayTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports